"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var version_1 = require("../util/version");
var storage_1 = tslib_1.__importDefault(require("../storage"));
var MetadataManager = /** @class */ (function () {
    function MetadataManager(pollingConfig) {
        this.pollingSeconds = pollingConfig.interval / 1000;
    }
    MetadataManager.prototype.updateClientCauseReason = function (reason) {
        this.clientCauseReason = reason;
    };
    MetadataManager.prototype.updateClientUserState = function (state) {
        this.clientUserState = state;
    };
    MetadataManager.prototype.get = function () {
        var metadata = {
            client: {
                name: 'feature-flag-web-client',
                version: version_1.version,
            },
            config: {
                pollingSeconds: this.pollingSeconds,
            },
            state: {
                // Need to cast VisibilityState (type) to ClientVisibilityState (enum)
                visibility: document.visibilityState,
                storage: storage_1.default.getStorageStatus(),
                userContext: this.clientUserState,
                cause: this.clientCauseReason,
            },
        };
        return metadata;
    };
    return MetadataManager;
}());
exports.default = MetadataManager;
